import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {BrandBuildingsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {pluralize} from "@pg-mono/string-utils";

import {getFullKMLink} from "../../utils/get_full_km_link";

interface IProps {
    recommendationCount: number;
}

export const KMOfferRecommendations = (props: IProps) => {
    return (
        <div css={wrapperStyle}>
            <div css={iconWrapperStyle}>
                <BrandBuildingsIcon size="12" />
            </div>
            <Text variant="headline_4" align="center" css={p(0, 2)}>
                Przygotowaliśmy dla Ciebie{" "}
                <strong>
                    {props.recommendationCount} {recommendationPartOnePluralize(props.recommendationCount)}
                </strong>{" "}
                {recommendationPartTwoPluralize(props.recommendationCount)} twoje kryteria
            </Text>
            <Button variant="filled_secondary" type="button" target="_blank" href={getFullKMLink(kmAppLink.site.offers.recommendedWithParams)}>
                zobacz rekomendacje
            </Button>
        </div>
    );
};

const recommendationPartOnePluralize = pluralize(["rekomendację", "rekomendacje", "rekomendacji"]);
const recommendationPartTwoPluralize = pluralize(["oferty, spełniającą", "ofert, spełniających", "ofert, spełniających"]);

const wrapperStyle = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(4)};
    background-color: ${theme.colors.primary};
    ${borderRadius(2)};
    ${p(4, 2)};
`;

const iconWrapperStyle = css`
    height: 12rem;
    ${flexAbsoluteCenter};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {BrandBuildingsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {pluralize} from "@pg-mono/string-utils";

import {getFullKMLink} from "../../utils/get_full_km_link";

interface IProps {
    recommendationCount: number;
}

export const KMOfferRecommendations = (props: IProps) => {
    return (
        <div css={wrapperStyle}>
            <div css={iconWrapperStyle}>
                <BrandBuildingsIcon size="12" />
            </div>
            <Text variant="headline_4" align="center" css={p(0, 2)}>
                Przygotowaliśmy dla Ciebie{" "}
                <strong>
                    {props.recommendationCount} {recommendationPartOnePluralize(props.recommendationCount)}
                </strong>{" "}
                {recommendationPartTwoPluralize(props.recommendationCount)} twoje kryteria
            </Text>
            <Button variant="filled_secondary" type="button" target="_blank" href={getFullKMLink(kmAppLink.site.offers.recommendedWithParams)}>
                zobacz rekomendacje
            </Button>
        </div>
    );
};

const recommendationPartOnePluralize = pluralize(["rekomendację", "rekomendacje", "rekomendacji"]);
const recommendationPartTwoPluralize = pluralize(["oferty, spełniającą", "ofert, spełniających", "ofert, spełniających"]);

const wrapperStyle = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(4)};
    background-color: ${theme.colors.primary};
    ${borderRadius(2)};
    ${p(4, 2)};
`;

const iconWrapperStyle = css`
    height: 12rem;
    ${flexAbsoluteCenter};
`;
